import List from "./BaseList";

 const { ccclass, property, disallowMultiple, menu, executionOrder } = cc._decorator;

 @ccclass
 @disallowMultiple()
 @menu('Framework/UI组件/BaseListItem')
 @executionOrder(-5001)          //先于List
 export default class BaseListItem extends cc.Component {

     //自适应尺寸
     @property({
         tooltip: CC_DEV && '自适应尺寸（宽或高）',
     })
     adaptiveSize: boolean = false;
     
     //依赖的List组件
     public list: List;
     //是否已经注册过事件
     private _eventReg = false;
     //序列id
     public listId: number;
 
     onLoad() {
     }
 
     onDestroy() {
         this.node.off(cc.Node.EventType.SIZE_CHANGED, this._onSizeChange, this);
     }
 
     _registerEvent() {
         if (!this._eventReg) {
             if (this.adaptiveSize) {
                 this.node.on(cc.Node.EventType.SIZE_CHANGED, this._onSizeChange, this);
             }
             this._eventReg = true;
         }
     }
 
     _onSizeChange() {
         this.list._onItemAdaptive(this.node);
     }
     
     showAni(aniType: number, callFunc: Function, del: boolean) {
         let t: any = this;
         let tween: cc.Tween;
         switch (aniType) {
             case 0: //向上消失
                 tween = cc.tween(t.node)
                     .to(.2, { scale: .7 })
                     .by(.3, { y: t.node.height * 2 });
                 break;
             case 1: //向右消失
                 tween = cc.tween(t.node)
                     .to(.2, { scale: .7 })
                     .by(.3, { x: t.node.width * 2 });
                 break;
             case 2: //向下消失
                 tween = cc.tween(t.node)
                     .to(.2, { scale: .7 })
                     .by(.3, { y: t.node.height * -2 });
                 break;
             case 3: //向左消失
                 tween = cc.tween(t.node)
                     .to(.2, { scale: .7 })
                     .by(.3, { x: t.node.width * -2 });
                 break;
             default: //默认：缩小消失
                 tween = cc.tween(t.node)
                     .to(.3, { scale: .1 });
                 break;
         }
         if (callFunc || del) {
             tween.call(() => {
                 if (del) {
                     t.list._delSingleItem(t.node);
                     for (let n: number = t.list.displayData.length - 1; n >= 0; n--) {
                         if (t.list.displayData[n].id == t.listId) {
                             t.list.displayData.splice(n, 1);
                             break;
                         }
                     }
                 }
                 callFunc();
             });
         }
         tween.start();
     }
 }
 